// extracted by mini-css-extract-plugin
export default {"terms":"Terms-module__terms__a5Ihh","title":"Terms-module__title__Fkqez","backButton":"Terms-module__backButton__yS+le","backButtonContent":"Terms-module__backButtonContent__3c0zf"};